import React from 'react';
import './SocialLinks.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faTiktok, 
  faGithub, 
  faFacebookF, 
  faInstagram 
} from '@fortawesome/free-brands-svg-icons';

const SocialLinks = () => {
  const socialMedia = [
    {
      name: 'TikTok',
      url: 'https://tiktok.com/@bagas_oscarius',
      icon: faTiktok,
      color: 'tiktok',
      className: 'tiktok'
    },
    {
      name: 'GitHub',
      url: 'https://github.com/BagasExpoit',
      icon: faGithub,
      color: 'github',
      className: 'github'
    },
    {
      name: 'Facebook',
      url: 'https://facebook.com/willydevops1',
      icon: faFacebookF,
      color: 'facebook',
      className: 'facebook'
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/bagas_samuji74?igsh=bmlscWxqN2pmZnJx',
      icon: faInstagram,
      color: 'instagram',
      className: 'instagram'
    }
  ];

  return (
    <div className="social-links">
      {socialMedia.map((social, index) => (
        <a
          key={index}
          href={social.url}
          className={`social-link ${social.className} ${index === 1 ? 'pulse' : ''}`}
          title={social.name}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Kunjungi ${social.name} saya`}
        >
          <FontAwesomeIcon icon={social.icon} className="icon" />
          <span className="tooltip">{social.name}</span>
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
